// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   FaUsers,
//   FaLandmark,
//   FaShieldAlt,
//   FaMapMarkedAlt,
//   FaUniversity,
// } from "react-icons/fa";
// import banner1 from "../../Assets/banner1.jpg";
// import banner2 from "../../Assets/banner2.jpg";
// import banner3 from "../../Assets/banner3.jpg";
// import { mainRouteInitial } from "../../Data/Constant";
// import "./VidhanSabhaDashboard.css";

// const constituencyList = [
//   {
//     id: "VS1",
//     codeNumber: "388",
//     name: "Varanasi North",
//     nameEnglish: "388 Varanasi North",
//     nameHindi: "वाराणसी उत्तर",
//     themeClass: "vsd-theme-north",
//     iconBg: "rgba(147, 112, 219, 0.45)",
//     icon: <FaUsers />,
//     count: 0,
//   },
//   {
//     id: "VS2",
//     codeNumber: "389",
//     name: "Varanasi South",
//     nameEnglish: "389 Varanasi South",
//     nameHindi: "वाराणसी दक्षिण",
//     themeClass: "vsd-theme-south",
//     iconBg: "rgba(219, 84, 97, 0.50)",
//     icon: <FaLandmark />,
//     count: 0,
//   },
//   {
//     id: "VS3",
//     codeNumber: "390",
//     name: "Varanasi Cantonment",
//     nameEnglish: "390 Varanasi Cantonment",
//     nameHindi: "वाराणसी कैंट",
//     themeClass: "vsd-theme-cantt",
//     iconBg: "rgba(235, 130, 60, 0.55)",
//     icon: <FaShieldAlt />,
//     count: 0,
//   },
//   {
//     id: "VS4",
//     codeNumber: "387",
//     name: "Rohaniya",
//     nameEnglish: "387 Rohaniya",
//     nameHindi: "रोहनिया",
//     themeClass: "vsd-theme-rohaniya",
//     iconBg: "rgba(230, 95, 80, 0.55)",
//     icon: <FaMapMarkedAlt />,
//     count: 0,
//   },
//   {
//     id: "VS5",
//     codeNumber: "391",
//     name: "Sevapuri",
//     nameEnglish: "391 Sevapuri",
//     nameHindi: "सेवापुरी",
//     themeClass: "vsd-theme-sevapuri",
//     iconBg: "rgba(138, 171, 60, 0.55)",
//     icon: <FaUniversity />,
//     count: 0,
//   },
// ];

// const bannerImages = [banner1, banner2, banner3];
// const totalSlides = bannerImages.length;

// const VidhanSabhaDashboard = () => {
//   const navigate = useNavigate();

//   // Infinite banner slider state
//   const [activeSlide, setActiveSlide] = useState(0);
//   const [isTransitioning, setIsTransitioning] = useState(true);
//   const sliderRef = useRef(null);
//   const trackRef = useRef(null);

//   // Auto-advance
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setIsTransitioning(true);
//       setActiveSlide((prev) => prev + 1);
//     }, 6000);
//     return () => clearInterval(interval);
//   }, []);

//   // Infinite loop snap
//   useEffect(() => {
//     if (activeSlide === totalSlides) {
//       const track = trackRef.current;
//       if (!track) return;
//       const onTransitionEnd = () => {
//         setIsTransitioning(false);
//         setActiveSlide(0);
//         track.removeEventListener("transitionend", onTransitionEnd);
//       };
//       track.addEventListener("transitionend", onTransitionEnd);
//     }
//     if (activeSlide === 0 && !isTransitioning) {
//       requestAnimationFrame(() => setIsTransitioning(true));
//     }
//   }, [activeSlide, isTransitioning]);

//   const handleCardClick = (item) => {
//     navigate(`/${mainRouteInitial}/Dashboard`, {
//       state: {
//         selectedVS: item.id,
//         vsName: item.nameEnglish,
//         vsNameHindi: item.nameHindi,
//       },
//     });
//   };

//   return (
//     <div className="vsd-container">
//       {/* 1. TOP AUTO SCROLL IMAGE BANNER SLIDER */}
//       {/* <div className="vsd-bannerSlider" ref={sliderRef}>
//         <div
//           ref={trackRef}
//           className="vsd-bannerTrack"
//           style={{
//             transform: `translateX(-${activeSlide * 100}%)`,
//             transition: isTransitioning
//               ? "transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)"
//               : "none",
//           }}
//         >
//           {bannerImages.map((img, index) => (
//             <div key={index} className="vsd-bannerSlide">
//               <img
//                 src={img}
//                 alt={`banner-${index + 1}`}
//                 className={index === 2 ? "vsd-bannerImg3" : "vsd-bannerImg"}
//               />
//             </div>
//           ))}

//           <div className="vsd-bannerSlide">
//             <img
//               src={bannerImages[0]}
//               alt="banner-clone"
//               className="vsd-bannerImg"
//             />
//           </div>
//         </div>

//         <div className="vsd-bannerDots">
//           {bannerImages.map((_, i) => (
//             <button
//               key={i}
//               className={`vsd-bannerDot${activeSlide % totalSlides === i ? " active" : ""
//                 }`}
//               onClick={() => {
//                 setIsTransitioning(true);
//                 setActiveSlide(i);
//               }}
//             />
//           ))}
//         </div>
//       </div> */}
//       {/* 2. BANNER NICHE PART - EXACT DESIGN FROM IMAGE */}
//       <div className="vsd-hero-section" style={{ backgroundImage: `url(${banner1})` }}  >
//         <div className="vsd-hero-content">
//           {/* Title */}
//           <h1 className="vsd-hero-title">Varanasi Lok Sabha</h1>

//           {/* Golden Divider with Icon */}
//           <div className="vsd-divider-wrapper">
//             <div className="vsd-divider-line"></div>
//             <div className="vsd-divider-icon-box">
//               <FaLandmark />
//             </div>
//             <div className="vsd-divider-line"></div>
//           </div>

//           {/* 5 Glassmorphic Constituency Cards */}
//           <div className="vsd-cards-grid">
//             {constituencyList.map((item) => (
//               <div
//                 key={item.id}
//                 className={`vsd-glass-card ${item.themeClass}`}
//                 onClick={() => handleCardClick(item)}
//               >
//                 {/* Top Circular Colored Icon Badge */}
//                 <div
//                   className="vsd-card-top-icon-wrapper"
//                   style={{ backgroundColor: item.iconBg }}
//                 >
//                   {item.icon}
//                 </div>

//                 {/* Code Number (388, 389, 390, 387, 391) */}
//                 <div className="vsd-card-main-number">{item.codeNumber}</div>

//                 {/* Constituency Name */}
//                 <div className="vsd-card-constituency-name">{item.name}</div>

//                 {/* Thin Line Divider */}
//                 <div className="vsd-card-inner-divider"></div>

//                 {/* Bottom Count */}
//                 <div className="vsd-card-bottom-count">{item.count}</div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default VidhanSabhaDashboard;

import React, { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { FaUsers, FaLandmark, FaShieldAlt, FaMapMarkedAlt, FaUniversity } from "react-icons/fa";
import banner1 from "../../Assets/banner1.jpg";
import banner2 from "../../Assets/banner2.jpg";
import banner3 from "../../Assets/banner3.jpg";
import { mainRouteInitial } from "../../Data/Constant";
import "./VidhanSabhaDashboard.css";
import { useVidhanSabhaCountDetail } from "../../API_Master/FetchAPI";

const constituencyList = [
  {
    id: "VS4",
    codeNumber: "387",
    name: "Rohaniya",
    nameEnglish: "387 Rohaniya",
    nameHindi: "रोहनिया",
    themeClass: "vsd-theme-rohaniya",
    iconBg: "rgba(230, 95, 80, 0.55)",
    icon: <FaLandmark />,
    count: 0,
  },
  {
    id: "VS1",
    codeNumber: "388",
    name: "Varanasi North",
    nameEnglish: "388 Varanasi North",
    nameHindi: "वाराणसी उत्तर",
    themeClass: "vsd-theme-north",
    iconBg: "rgba(147, 112, 219, 0.45)",
    icon: <FaLandmark />,
    count: 0,
  },
  {
    id: "VS2",
    codeNumber: "389",
    name: "Varanasi South",
    nameEnglish: "389 Varanasi South",
    nameHindi: "वाराणसी दक्षिण",
    themeClass: "vsd-theme-south",
    iconBg: "rgba(219, 84, 97, 0.50)",
    icon: <FaLandmark />,
    count: 0,
  },
  {
    id: "VS3",
    codeNumber: "390",
    name: "Varanasi Cantonment",
    nameEnglish: "390 Varanasi Cantonment",
    nameHindi: "वाराणसी कैंट",
    themeClass: "vsd-theme-cantt",
    iconBg: "rgba(235, 130, 60, 0.55)",
    icon: <FaLandmark />,
    count: 0,
  },

  {
    id: "VS5",
    codeNumber: "391",
    name: "Sevapuri",
    nameEnglish: "391 Sevapuri",
    nameHindi: "सेवापुरी",
    themeClass: "vsd-theme-sevapuri",
    iconBg: "rgba(138, 171, 60, 0.55)",
    icon: <FaLandmark />,
    count: 0,
  },
];

const bannerImages = [banner1, banner2, banner3];
const totalSlides = bannerImages.length;

const VidhanSabhaDashboard = () => {
  const navigate = useNavigate();

  // ------------------------------------------------------------
  // API: Vidhan Sabha beneficial count
  // ------------------------------------------------------------
  const { data: vidhanSabhaCountData } = useVidhanSabhaCountDetail(true);

  // Build a lookup: { "rohaniya": 18118, "sevapuri": 111616, ... }
  const countMap = useMemo(() => {
    const map = {};
    if (Array.isArray(vidhanSabhaCountData)) {
      vidhanSabhaCountData.forEach(({ Vidhansabha, BeneficialCount }) => {
        if (Vidhansabha) {
          map[Vidhansabha.trim().toLowerCase()] = BeneficialCount;
        }
      });
    }
    console.log("countMap =>", map);
    return map;
  }, [vidhanSabhaCountData]);

  const getCountFor = (name) => countMap[name?.trim().toLowerCase()] ?? 0;

  // Infinite banner slider state
  const [activeSlide, setActiveSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(true);
  const sliderRef = useRef(null);
  const trackRef = useRef(null);

  // Auto-advance
  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);
      setActiveSlide((prev) => prev + 1);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  // Infinite loop snap
  useEffect(() => {
    if (activeSlide === totalSlides) {
      const track = trackRef.current;
      if (!track) return;
      const onTransitionEnd = () => {
        setIsTransitioning(false);
        setActiveSlide(0);
        track.removeEventListener("transitionend", onTransitionEnd);
      };
      track.addEventListener("transitionend", onTransitionEnd);
    }
    if (activeSlide === 0 && !isTransitioning) {
      requestAnimationFrame(() => setIsTransitioning(true));
    }
  }, [activeSlide, isTransitioning]);

  // ------------------------------------------------------------
  // Card click -> pass the Vidhansabha name
  // ------------------------------------------------------------
  // const handleCardClick = (item) => {
  //   navigate(`/${mainRouteInitial}/Dashboard`, {
  //     state: {
  //       selectedVS: item.id,
  //       vsName: item.nameEnglish,
  //       vsNameHindi: item.nameHindi,
  //       Vidhansabha: item.name, // <-- passed on card click
  //     },
  //   });
  // };

  const handleCardClick = (item) => {
    // Persist so ViewMemberList can restore it on refresh / new tab
    try {
      localStorage.setItem("selectedVidhanSabha", item.name);
    } catch (e) {
      // localStorage might be disabled (private mode, etc.) — safe to ignore
      console.warn("Failed to persist selectedVidhanSabha:", e);
    }

    navigate(`/${mainRouteInitial}/Dashboard`, {
      state: {
        selectedVS: item.id,
        vsName: item.nameEnglish,
        vsNameHindi: item.nameHindi,
        Vidhansabha: item.name, // <-- passed on card click
      },
    });
  };

  return (
    <div className="vsd-container">
      {/* 1. TOP AUTO SCROLL IMAGE BANNER SLIDER */}
      {/* <div className="vsd-bannerSlider" ref={sliderRef}>
        <div
          ref={trackRef}
          className="vsd-bannerTrack"
          style={{
            transform: `translateX(-${activeSlide * 100}%)`,
            transition: isTransitioning
              ? "transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)"
              : "none",
          }}
        >
          {bannerImages.map((img, index) => (
            <div key={index} className="vsd-bannerSlide">
              <img
                src={img}
                alt={`banner-${index + 1}`}
                className={index === 2 ? "vsd-bannerImg3" : "vsd-bannerImg"}
              />
            </div>
          ))}

          <div className="vsd-bannerSlide">
            <img
              src={bannerImages[0]}
              alt="banner-clone"
              className="vsd-bannerImg"
            />
          </div>
        </div>

        <div className="vsd-bannerDots">
          {bannerImages.map((_, i) => (
            <button
              key={i}
              className={`vsd-bannerDot${
                activeSlide % totalSlides === i ? " active" : ""
              }`}
              onClick={() => {
                setIsTransitioning(true);
                setActiveSlide(i);
              }}
            />
          ))}
        </div>
      </div> */}

      {/* 2. BANNER NICHE PART - EXACT DESIGN FROM IMAGE */}
      <div className="vsd-hero-section" style={{ backgroundImage: `url(${banner1})` }}>
        <div className="vsd-hero-content">
          {/* Title */}
          <h1 className="vsd-hero-title">Varanasi Lok Sabha</h1>

          {/* Golden Divider with Icon */}
          <div className="vsd-divider-wrapper">
            <div className="vsd-divider-line"></div>
            <div className="vsd-divider-icon-box">
              <FaLandmark />
            </div>
            <div className="vsd-divider-line"></div>
          </div>

          {/* 5 Glassmorphic Constituency Cards */}
          <div className="vsd-cards-grid">
            {constituencyList.map((item) => (
              <div key={item.id} className={`vsd-glass-card ${item.themeClass}`} onClick={() => handleCardClick(item)}>
                {/* Top Circular Colored Icon Badge */}
                <div className="vsd-card-top-icon-wrapper" style={{ backgroundColor: item.iconBg }}>
                  {item.icon}
                </div>

                {/* Code Number (388, 389, 390, 387, 391) */}
                <div className="vsd-card-main-number">{item.codeNumber}</div>

                {/* Constituency Name */}
                <div className="vsd-card-constituency-name">{item.name}</div>

                {/* Thin Line Divider */}
                <div className="vsd-card-inner-divider"></div>

                {/* Bottom Count (from API) */}
                <div className="vsd-card-bottom-count">{getCountFor(item.name)}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VidhanSabhaDashboard;
